export const active = {
  1: 'Activo',
  0: 'Inactivo',
}

export const activeColor = {
  Activo: 'success',
  Inactivo: 'default',
}
